// extracted by mini-css-extract-plugin
module.exports = {"reminders":"Reminders_reminders__131aH","title":"Reminders_title__ElZbk","toggles":"Reminders_toggles__2U38l"};